import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationEntry, NavigationItemsService } from '@thehubz/client/core';

@Component({
  selector: 'thehubz-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.scss'],
})
export class LeftMenuComponent implements OnInit {
  menuItemList: NavigationEntry[] = [];

  constructor(private navigationItemsService: NavigationItemsService) {}

  ngOnInit(): void {
    this.menuItemList = this.navigationItemsService.getNavigation();
  }

  @HostListener('document:showMainMenu', ['$event'])
  onShowMainMenu(): void {
    this.showMenu();
  }

  @HostListener('document:hideMainMenu', ['$event'])
  onHideMainMenu(): void {
    this.hideMenu();
  }

  showMenu(): void {
    document.body.classList.add('show-main-menu');

    const mainMenu: HTMLElement | null = document.querySelector('#main-menu');
    if (mainMenu) mainMenu.focus();
  }

  hideMenu(): void {
    document.body.classList.remove('show-main-menu');

    const mainMenuShowButton: HTMLButtonElement | null = document.querySelector('#main-menu-show-button');
    if (mainMenuShowButton) mainMenuShowButton.focus();
  }
}
